import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { useMutation } from '@apollo/react-hooks';
import { Panel } from 'primereact/panel';
import { useHistory } from 'react-router-dom';
import RespondentImportDropzone from '../../../components/FileImportDropzone';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { growlErrors } from '../../../utils/NotificationUtil';

const messages = defineMessages({
  import: { id: 'res_import.file_field_label', defaultMessage: 'Import Respondents' },
});

const IMPORT_RESPONDENTS = gql`
  mutation importAccountRespondents($input: AccountRespondentDefinitionsImportInput!) {
    importAccountRespondents(input: $input) {
      id
      status
      overwrite
      fileName
      createdOn
      updatedOn
    }
  }
`;

/**
 * Renders the page to create new respondent imports
 * @param {*} props
 */
const NewRespondentImport = (props) => {
  const [importRespondentsMutation] = useMutation(IMPORT_RESPONDENTS, {
    refetchQueries: ['allRespondentImports'],
  });

  const history = useHistory();
  const { formatMessage } = useIntl();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const onUpload = async (files) => {
    try {
      const file = files[0];

      const result = await importRespondentsMutation({
        variables: {
          input: {
            accountId: currentAccount,
            // this is the name that apollo-file-uploads puts ... :(
            fieldName: '1',
          },
          file,
        },
      });

      if (result.data) {
        const { id } = result.data.importAccountRespondents;
        history.push(`/accounts/${currentAccount}/respondents/imports/${id}`);
      }
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <Panel header={formatMessage(messages.import)}>
            <div className="p-grid">
              <div className="p-col-12">
                <RespondentImportDropzone
                  onUpload={onUpload}
                  onCancel={() => history.push(`/accounts/${currentAccount}/respondents/imports`)}
                />
              </div>
              <div className="p-col-12">
                <a target="_blank" href="/import-templates/import-respondents.xlsx">
                  <FormattedMessage id="res_import.download_hint" defaultMessage="Download Import Template file" />
                </a>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default NewRespondentImport;
